module.exports = __webpack_public_path__ + "static/logo-website-e2e8a8b7ada53e335167aa789fa33fe5.png";